<template>
  <div>
    <navigationFab />

    <v-img
      src="https://images.unsplash.com/photo-1504509546545-e000b4a62425?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="25vh"
    >
      <v-row>
        <v-col class="mt-16" align="center">
          <span class="primary--text text-md-h2 text-h3 font-weight-bold"
            >Documentation</span
          >
        </v-col>
      </v-row>
    </v-img>
    <div class="px-8 pb-16">
      <v-row>
        <v-col align="center">
          <span class="primary--text text-md-h4 text-h5 font-weight-bold"
            >Problem</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6">
          <span class="font-weight-bold">Imagine this...</span><br /><br />You
          are on a hurry but still want to listen to your favourite songs. So
          probably you got a Playlist with all of your 600 favourite Songs.
          You're starting your playlist on shuffle and damn... The first song is
          one you're already sick of, since you heard it all day. So you keep
          skipping, waiting for a song you like at the moment. Once you found it
          you're having your 3 min of peace before the whole thing starts over
          again... Skipping through your playlist all day long...<br /><br /><span
            class="font-weight-bold"
            >Or this...</span
          ><br /><br />You have a playlist with your favourite 30 songs. You add
          and delete songs every now and then to stay around a count of 30 songs
          in that playlist. You're already avoiding the problem skipping through
          your playlist mentioned above. But you may want to have a playlist
          with all the songs you ever had in your "Favourites"-Playlist to
          rediscover of your old favourite songs.
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <span class="primary--text text-md-h4 text-h5 font-weight-bold"
            >Solution - Listify Playlist-System</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6">
          Splitting your "Favourites"-Playlist in three categories:<br /><br />
          <ul>
            <li>1 Current Favourites Playlist (Approx. 30 Songs)</li>
            <li>
              1 Alltime Favourites Playlist (Every Song that was in your
              "Current Favourites")
            </li>
            <li>
              X Current Favourites History Playlists (Copying your "Current
              Favourites"-Playlist before you rework it and add a Time-Range in
              the Playlist-Title)
            </li>
          </ul>
          <br />
          Every time before you rework your Current Favourites Playlist you
          <router-link to="/">Listify</router-link> your Spotify-Library.
          Listify automatically adds a History Playlist to your Spotify Library
          and adds all your Current Favourites to your Alltime Favourites
          Playlist. After that, you can rework your Current Favourites
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <span class="primary--text text-md-h4 text-h5 font-weight-bold"
            >Benefits</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6">
          <ul>
            <li>No more skipping on your daily Playlist</li>
            <li>Large Playlist with all of your favourites for long drives</li>
            <li>Throwbacks to your past favourites</li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <span class="primary--text text-md-h4 text-h5 font-weight-bold"
            >Requirements</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6">
          <ul>
            <li>Spotify Premium Account</li>
            <li>1 Current Favourites Playlist</li>
            <li>1 Alltime Favourites Playlist</li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center">
          <span class="primary--text text-md-h4 text-h5 font-weight-bold"
            >How it works</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6">
          The first thing you need to do is connecting your Spotify-Account with
          Listify. You will be redirected to a spotify login-dialog
          automatically if its your first time listifying.<br /><br />With
          logging in you'll grant Listify access to the following scopes:
          <ul>
            <li>
              <span class="primary--text">Modifying public playlists</span>:
              Needed to add songs to your Alltime Favourites Playlist if it is a
              public playlist
            </li>
            <li>
              <span class="primary--text">Modifying private playlists</span>:
              Needed to add songs to your Alltime Favourites Playlist if it is a
              private playlist
            </li>
            <li>
              <span class="primary--text">Read private user</span>: Needed to
              get all your playlist to let you select your Current & Alltime
              Favourites Playlist
            </li>
            <li>
              <span class="primary--text">Read User Top Values</span>: Needed to
              gather statistic information for the profile page
            </li>
          </ul>
          <br />
          After you've done this you'll be redirected back to listify. Now
          you'll see your Spotify-Profile.<br />You'll see how much followers
          you have, what your favourite Genre is, who your favourite Artist is
          and how many playlists you got in your Spotify-Library.<br />
          <br />
          With a click on "Playlist Selection" you must select and provide your
          information in order to Listify your Library.<br />
          We need to know:
          <ul>
            <li>
              <span class="primary--text">Current Favourites Playlist</span>: A
              Playlist with approx. 30 of your current favourite tracks
            </li>
            <li>
              <span class="primary--text">Alltime Favourites Playlist</span>:
              The Playlist where you want to keep all your songs you ever
              selected to be one of your favourites
            </li>
            <li>
              <span class="primary--text">Favourites History Playlist Name</span
              >: The Name of your History Playlists. Don't add a Date-Range to
              it, since we'll do that for you anyway :P (Only if "Remember Me?"
              is selected!)
            </li>
            <li>
              <span class="primary--text"
                >Current Favourites Playlist Behavior</span
              >:<br />
              How do you want to go on with your selected Current Favourites
              Playlist? You have the following three possibilities:
              <ul>
                <li>
                  Completely clear the playlist and fill it again by yourself
                </li>
                <li>
                  Edit your Playlist via Listify - You'll have the opportunity
                  to delete selected songs from your playlist after listifying
                </li>
                <li>Don't do anything with it - Leave it like it is</li>
              </ul>
            </li>
            <li>
              <span class="primary--text">Remember me</span>: We'll store a
              dataset containing your Spotify-ID, Current Favourites
              Playlist-ID, Alltime Favourites Playlist-ID, Favourites History
              Playlist-Name, Current Favourites Playlist Behavior and the date
              of your last time listifying. The next time you use Listify to
              manage your Spotify-Library you won't need to enter the
              information mentioned above
            </li>
          </ul>
          <br />
          With a click on "Go!" we'll Listify your playlist system.
          <br />
          If you didn't chose to edit your Current Favourites Playlist after
          listifying your done now!<br /><br />Otherwise you will see a list of
          the songs which are in your Current Favourites Playlist.<br />Select
          the ones you want to remove from the playlist. After selecting simply
          press "Remove Selected".<br /><br />You're done too now!<br /><br />Enjoy
          your listified playlist system!<br />Come back when you start skipping
          again :P
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import navigationFab from "../components/general/navigationFab";
export default {
  name: "Documentation",
  title: "Documentation",
  components: {
    navigationFab,
  },
  data() {
    return {
      fab: false,
    };
  },
};
</script>

<style scoped>
</style>